export default __webpack_public_path__ + "images/description_icon.b1ac5c3.png";